import makeRequest from './makeRequest';
import environment from 'environment';

export const sendPasswordReset = async (customerId, simplrAccountId, conversationId) => {
  if (!customerId || !simplrAccountId) {
    throw new Error('Looks like there is no selected customer');
  }

  const data = { simplrAccountId, conversationId };

  return await makeRequest(`${environment.customerData.CUSTOMER_BASE_URL}/${customerId}/passwordReset`, {
    method: 'post',
    data,
  });
};
